import React from 'react';
import { MagnifyingGlassIcon, PencilIcon, FunnelIcon, ChevronDownIcon, ChevronUpIcon, CalendarIcon} from '@heroicons/react/20/solid';
import { 
    UserIcon, 
    LockClosedIcon, 
    ExclamationTriangleIcon,
    ShieldCheckIcon,
    XMarkIcon,
    InformationCircleIcon
} from '@heroicons/react/24/outline';
import Breadcrumb from '../../Shared/BreadCumb';
import { getAllPenalities} from '../penalities/services/penalities';
import ClipLoader from "react-spinners/ClipLoader";
import ResponsiveTable from '../../Shared/ResponsiveTable';
import { DialogPanel, Dialog, DialogBackdrop } from '@headlessui/react';
import { penalitieStatus } from '../penalities/services/penalities';
import { login } from '../login/services/login';
import { ToastContainer, toast } from 'react-toastify';


export default class NullationComponent extends React.Component {

    BreadcrumbPages = [ 
            { name: 'Multas', href: '#', current: false },
            { name: 'Lista de multas', href: '#', current: true },
        ]
        userCanEdit = false;
        
        renderDateAnnulment = (params) => {
            if(params.row.descripStatus === 'LLAMADO DE ATENCIÓN' && params.row.dateAnnulment !== '1900-01-01T00:00:00Z') {
                return this.formatDate(params.row.dateAnnulment);
            }
            return 'N/A';
        }

        columns = [
            {field:'fullnameUser', headerName: 'Nombre completo'},
            {field:'identificationUser', headerName: 'Identificación'},
            {field:'code', headerName: 'Código de la Advertencia'},
            {field:'dateReg', headerName: 'Fecha de registro'},
            {field:'dateAnnulment', headerName: 'Fecha de llamado de atención', renderCell: this.renderDateAnnulment},
            {field:'descripStatus', headerName: 'Estatus'},
            {field:'numberPlate', headerName: 'Placa'},
            {field:'totalBS', headerName: 'Monto'},
            {field:'remainder', headerName: 'Restante'},
        ];

        renderActions = (row) => {
        if (row.status === 4 || row.descripStatus === 'LLAMADO DE ATENCIÓN' || row.descripStatus === 'REVOCACIÓN') return null;
            
            return (
                <button 
                    title='Actualizar estado'
                    onClick={() => {
                        this.setState({changeStatus:true, penalitie:row})
                    }}
                    type="button"
                    className="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                    <PencilIcon aria-hidden="true" className="h-5 w-5" />
                </button>
            );
        }

        bankAccounts = [

            { value: "0102", label: "Banco de Venezuela, S.A.C.A." },
            { value: "0104", label: "Venezolano de Crédito" },
            { value: "0105", label: "Mercantil" },
            { value: "0108", label: "Provincial" },
            { value: "0114", label: "Bancaribe" },
            { value: "0115", label: "Exterior" },
            { value: "0116", label: "Occidental de Descuento" },
            { value: "0128", label: "Banco Caroní" },
            { value: "0134", label: "Banesco" },
            { value: "0138", label: "Banco Plaza" },
            { value: "0137", label: "Banco Sofitasa" },
            { value: "0146", label: "Bangente" },
            { value: "0151", label: "BFC Banco Fondo Común" },
            { value: "0156", label: "100% Banco" },
            { value: "0157", label: "Del Sur" },
            { value: "0163", label: "Banco del Tesoro" },
            { value: "0166", label: "Banco Agrícola de Venezuela" },
            { value: "0168", label: "Bancrecer" },
            { value: "0169", label: "Mi Banco" },
            { value: "0172", label: "Bancamiga" },
            { value: "0174", label: "Banplus" },
            { value: "0175", label: "Banco Digital de los Trabajadores,Banco Universal" },
            { value: "0177", label: "Banfanb" },
            { value: "0191", label: "BNC Nacional de Crédito" },
            { value: "0171", label: "Banco Activo" },
    
        ];

    constructor(props){
        super(props)
        this.state = {
            loading:false,
            identification:'',
            numberPlate:'',
            // dateEnd:new Date().toISOString().split('T')[0],
            // dateStart:new Date().toISOString().split('T')[0] ,
            dateEnd:'',
            dateStart:'' ,
            penalities:[],
            detailPenalitie:false,
            penalitie:null,
            changeStatus:false,
            status:-1,
            loadingForm:false,
            payment:false,
            limit:100,

            /*PAYMENTS*/
            paymentType:'',
            paymentCost:'',
            paymentRef: '',
            paymentBank: '',

            name: '',
            identificationPayment:'',
            phone: '',
            bankCode: '',
            bank: '',
            account:'',
            dateTrans: new Date().toISOString().slice(0, 10),


            canExonere: false,
            canCreate: false,
            canEdit: false,
            canSee: false,
            canUpdateStatus: false,
            confirm:false, // modal confirm

            //tabs
            tabs: [
                {name: 'Detalles de la Persona', href:'#', current:true, id:0},
                {name: 'Detalles de la Multa', href:'#', current:false, id:1},
                {name: 'Detalles de pago', href:'#', current:false, id:2}
            ],

            username: '',
            password: '',

            // UI state
            isFiltersOpen: true,

            // filtro para codigo de la multa
            codeFine: '',

            comment: '',
        }
    }

    componentDidMount() {}

    renderColorByValue(value){
        if(value === 'PENDIENTE POR PAGAR'){
            return(
                <span className="inline-flex items-center rounded-full bg-red-100 px-1.5 py-0.5 text-xs font-medium text-red-600 ">
                    PENDIENTE POR PAGAR
                </span>
            )
        }
        if(value === 'PAGO PARCIAL'){
            return(
                <span className="inline-flex items-center rounded-full bg-yellow-100 px-1.5 py-0.5 text-xs font-medium text-yellow-600 ">
                    PAGO PARCIAL
                </span>
            )
        }
        if(value === 'PAGADA'){
            return(
                <span className="inline-flex items-center rounded-full bg-green-100 px-1.5 py-0.5 text-xs font-medium text-green-600 ">
                    PAGADA
                </span>
            )
        }
        if(value === 'MOROSIDAD'){
            return(
                <span className="inline-flex items-center rounded-full bg-orange-100 px-1.5 py-0.5 text-xs font-medium text-orange-600 ">
                    MOROSA
                </span>
            )
        }
        if(value === 'LLAMADO DE ATENCIÓN'){
            return(
                <span className="inline-flex items-center rounded-full bg-gray-100 px-1.5 py-0.5 text-xs font-medium text-gray-600 ">
                    LLAMADO DE ATENCIÓN
                </span>
            )
        }
      }


    getData = () => {
        const body = this.bodyData();
        if(body){
            this.setState({loading:true});
            getAllPenalities(body)
            .then((result) => {
                if(result && result.status === 200) {
                    let fines = [];
                    result.data.data.forEach((item) => {
                        if(item.headerFine) {
                            item.headerFine.forEach((fine) => {
                                fine.identificationUser = item.identification;
                                fine.fullnameUser = item.firstName + ' ' + item.middleName;
                                fine.userEmail = item.email;
                                fines.push(fine);
                            });
                        }
                    });
                        fines = fines.sort((a, b) => {
                            return Date.parse(b.dateReg) - Date.parse(a.dateReg);
                          });
                          
                        this.setState({penalities:fines, loading:false});
                }else{
                    toast('No se encontraron resultados');
                    this.setState({penalities:[], loading:false});
                }  
                
            }).catch((error) => {
                toast(error);
                this.setState({loading:false})
                console.log(error)
            })
        }
    }

    regex = (value) => {
        if(value !== '') {
            const regex = /^\d+$/;
            if(regex.test(value) === true){
                return value
            }
            return null
        }
        return true
    }


    bodyData = () => {
        const body = {}
        if(this.state.identification !== '') {
            body.identification = this.state.identification;
        }
        if(this.state.numberPlate !== '') {
            body.numberPlate = this.state.numberPlate;
        }
        if(this.state.dateStart !== '') {
            body.dateStart = new Date(this.state.dateStart).toISOString();
        }
        if(this.state.dateEnd !== '') {
            body.dateEnd = new Date(this.state.dateEnd).toISOString();
        }
        if(this.state.status) {
            body.status = parseInt(this.state.status);
        }
        if(this.state.codeFine !== '') {
            body.code = this.state.codeFine;
        }
        body.limit = parseInt(this.state.limit);
        return body;
    }

        updateStatusCheck() {
            this.setState({loadingForm:true});
            login({user:this.state.username,password:this.state.password})
                .then((result) => {
                    if(result.status === 500 || result.status === 404) {
                        toast(result.response.data.message);
                        this.setState({username:'', password:''});
                        return;
                    }
                    if(result.data.data.idType === 99) {
                        this.setState({loadingForm:true});
                        penalitieStatus({
                            id:this.state.penalitie.idHeaderFine,
                            status:4,
                            comment: this.state.comment,
                        }).then((result) => {
                            if(result.status === 200) {
                                this.setState({loadingForm:false, changeStatus:false, penalitie:false, username:'', password:''});
                                this.getData();
                                return;
                            }else{
                                this.setState({loadingForm:false});
                                return;
                            }
                        }).catch((error) => console.log(error))
                    }
                }).catch((error) => {
                    toast(error);
                });
            this.setState({loadingForm:false});
        }


    setDateSearch = (type, value) => {
        if(type === 'start') {
            this.setState({dateStart:value.target.value});
        }else{
            this.setState({dateEnd:value.target.value});
        }
    }

    classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }


    formatDate = (date) => {
        const fecha = new Date(date);
        const horas = fecha.getHours();
        const minutos = fecha.getMinutes();
        const ampm = horas >= 12 ? 'PM' : 'AM';
        const horaFormateada = horas % 12 || 12;
        // ${horaFormateada}:${minutos.toString().padStart(2, '0')} ${ampm}
        return `${fecha.getDate()}/${(fecha.getMonth() + 1).toString().padStart(2, '0')}/${fecha.getFullYear()}`
    } 


    searchInput = () => {
        return (
            <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200">
                {/* Header del panel de filtros */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <div className="flex items-center space-x-2">
                        <FunnelIcon className="h-5 w-5 text-gray-500" />
                        <h3 className="text-lg font-semibold text-gray-900">Filtros de Llamado de Atención</h3>
                    </div>
                    <button
                        onClick={() => this.setState({isFiltersOpen: !this.state.isFiltersOpen})}
                        className="flex items-center text-sm text-gray-600 hover:text-gray-900"
                    >
                        {this.state.isFiltersOpen ? 'Ocultar' : 'Mostrar'} filtros
                        {this.state.isFiltersOpen ? 
                            <ChevronUpIcon className="ml-1 h-4 w-4" /> : 
                            <ChevronDownIcon className="ml-1 h-4 w-4" />
                        }
                    </button>
                </div>
                
                {/* Contenido del panel de filtros */}
                {this.state.isFiltersOpen && (
                    <div className="p-6">
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
                            <div>
                                <label htmlFor="identification" className="block text-sm font-medium text-gray-700 mb-2">
                                    Identificación
                                </label>
                                <input
                                    id="identification"
                                    value={this.state.identification}
                                    onChange={(e) => {
                                        if(this.regex(e.target.value)) {
                                            this.setState({identification:e.target.value})
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            this.getData()
                                        }
                                    }}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>
                            
                            <div>
                                <label htmlFor="numberPlate" className="block text-sm font-medium text-gray-700 mb-2">
                                    Placa del Vehículo
                                </label>
                                <input
                                    id="numberPlate"
                                    value={this.state.numberPlate}
                                    onChange={(e) => {this.setState({numberPlate:e.target.value})}}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            this.getData()
                                        }
                                    }}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>

                            <div>
                                <label htmlFor="codeFine" className="block text-sm font-medium text-gray-700 mb-2">
                                    Código de la Advertencia
                                </label>
                                <input
                                    id="codeFine"
                                    value={this.state.codeFine}
                                    onChange={(e) => {this.setState({codeFine:e.target.value})}}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            this.getData()
                                        }
                                    }}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>

                            <div>
                                <label htmlFor="dateStart" className="block text-sm font-medium text-gray-700 mb-2">
                                    <CalendarIcon className="inline h-4 w-4 mr-1" />
                                    Fecha Desde
                                </label>
                                <input
                                    id="dateStart"
                                    value={this.state.dateStart}
                                    onChange={(e) => {this.setDateSearch('start',e)}}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            this.getData()
                                        }
                                    }}
                                    type="date"
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>

                            <div>
                                <label htmlFor="dateEnd" className="block text-sm font-medium text-gray-700 mb-2">
                                    <CalendarIcon className="inline h-4 w-4 mr-1" />
                                    Fecha Hasta
                                </label>
                                <input
                                    id="dateEnd"
                                    value={this.state.dateEnd}
                                    onChange={(e) => {this.setDateSearch('end',e)}}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            this.getData()
                                        }
                                    }}
                                    type="date"
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>

                            <div>
                                <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-2">
                                    Estado de la Multa
                                </label>
                                <div className="relative">
                                    <select 
                                        id="status"
                                        onChange={(e) => {this.setState({status:e.target.value})}}
                                        className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                    >
                                        <option value={-1}>Todos los estados</option>
                                        <option value={0}>Pendiente por Pagar</option>
                                        {/*<option value={1}>En Pausa</option>*/}
                                        <option value={2}>En Morosidad</option>
                                        <option value={3}>Pagada</option>
                                        <option value={4}>Llamado de Atención</option>
                                        <option value={5}>Pago Parcial</option>
                                        <option value={6}>Revocada</option>
                                    </select>
                                </div>
                            </div>

                            <div>
                                <label htmlFor="limit" className="block text-sm font-medium text-gray-700 mb-2">
                                    Límite de Registros
                                </label>
                                <div className="relative">
                                    <select
                                        id="limit"
                                        onChange={(e) => {this.setState({limit:e.target.value})}}
                                        value={this.state.limit}
                                        className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                    >
                                        <option value={10}>10 registros</option>
                                        <option value={50}>50 registros</option>
                                        <option value={100}>100 registros</option>
                                        <option value={500}>500 registros</option>
                                        <option value={1000}>1000 registros</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        
                        {/* Botón de búsqueda */}
                        <div className="mt-6">
                            <button
                                onClick={() => this.getData()}
                                type="button"
                                className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-blue-950 rounded-md shadow-sm hover:bg-blue-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-950"
                            >
                                <MagnifyingGlassIcon aria-hidden="true" className="h-4 w-4 mr-2" />
                                Buscar
                            </button>
                        </div>
                    </div>
                )}
            </div>
        )
    }


    renderList = () => {
        return (
        <div className="max-w-7xl mx-auto px-4">
            <div className="py-6">
                {this.props.withoutNav ? null : <Breadcrumb pages={this.BreadcrumbPages}/>}
                
                <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Llamado de Atención de Multas</h2>
                    <p className="text-gray-600">Gestiona el llamado de atención de multas que requieren autorización especial</p>
                </div>

                {this.props.defaultFilter === false ? null : this.searchInput()}
                
                {/* Loading State */}
                {this.state.loading && (
                    <div className="text-center py-12">
                        <ClipLoader
                            handleClick={() => this.handleClick()}
                            color={'#1e40af'}
                            loading={true}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                        <p className="mt-2 text-sm text-gray-600">Cargando multas...</p>
                    </div>
                )}

                {/* Results Table */}
                {!this.state.loading && (
                    <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200 overflow-hidden">
                        <div className="px-6 py-4 border-b border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-900">Advertencias Disponibles para Llamado de Atención</h3>
                            <p className="text-sm text-gray-600">
                                {this.state.penalities.length} advertencia(s) encontrada(s)
                            </p>
                        </div>
                        <div className="w-full">
                            <ResponsiveTable 
                                onRowClick={(row) => {
                                    this.setState({changeStatus:true, penalitie:row})
                                }}
                                data={this.state.penalities} 
                                columns={this.columns} 
                                renderActions={(row) => this.renderActions(row)}
                            />
                        </div>
                    </div>
                )}
            </div>
            {this.updateStatus()}
            {this.modalConfirm()}

            {/* The toast */}
            <ToastContainer position="top-center" hideProgressBar={true}/>
        </div>
        )
    }

    modalConfirm = () => {
        return(
            <Dialog open={this.state.confirm} onClose={() => {
                this.setState({confirm:false})
            }} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in z-40"
                />
                
                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-md data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            {/* Header */}
                            <div className="bg-gradient-to-r from-blue-950 to-blue-900 px-6 py-4">
                                <div className="flex items-center">
                                    <div className="flex-shrink-0">
                                        <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                                            <ShieldCheckIcon className="h-6 w-6 text-white" />
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <h3 className="text-lg font-bold text-white">Confirmación de Seguridad</h3>
                                        <p className="text-blue-100 text-sm">Verifica tu identidad para continuar</p>
                                    </div>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="px-6 py-6">
                                <div className="space-y-6">
                                    {/* Campo de usuario */}
                                    <div>
                                        <label htmlFor="username" className="block text-sm font-semibold text-gray-700 mb-2">
                                            Nombre de Usuario
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <UserIcon className="h-5 w-5 text-gray-400" />
                                            </div>
                                            <input
                                                onChange={(e) => {this.setState({username:e.target.value})}}
                                                value={this.state.username}
                                                autoComplete="username"
                                                id="username"
                                                name="username"
                                                type="text"
                                                placeholder="Ingresa tu usuario"
                                                className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-950 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                                            />
                                        </div>
                                    </div>

                                    {/* Campo de contraseña */}
                                    <div>
                                        <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-2">
                                            Contraseña
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <LockClosedIcon className="h-5 w-5 text-gray-400" />
                                            </div>
                                            <input
                                                onChange={(e) => {this.setState({password:e.target.value})}}
                                                value={this.state.password}
                                                autoComplete="current-password"
                                                id="password"
                                                name="password"
                                                type="password"
                                                placeholder="Ingresa tu contraseña"
                                                className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-950 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="bg-gray-50 px-6 py-4 flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-3 space-y-3 space-y-reverse sm:space-y-0">
                                <button
                                    type="button"
                                    onClick={() => {this.setState({confirm:false})}}
                                    className="w-full sm:w-auto inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-950 transition-colors duration-200"
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        this.setState({confirm:false});
                                        this.updateStatusCheck();
                                    }}
                                    disabled={!this.state.username || !this.state.password}
                                    className="w-full sm:w-auto inline-flex justify-center items-center px-4 py-2 text-sm font-semibold text-white bg-gradient-to-r from-blue-950 to-blue-900 rounded-lg hover:from-blue-900 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-950 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105"
                                >
                                    <ShieldCheckIcon className="h-4 w-4 mr-2" />
                                    Confirmar Acción
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        )
    }

        updateStatus = () => {
            return(
                <Dialog open={this.state.changeStatus} onClose={()=>{
                    this.setState({changeStatus:false, penalitie:null})
                }} className="relative z-50">
                    <DialogBackdrop
                        transition
                        className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in z-40"
                    />
                    
                    <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4">
                            <DialogPanel
                                transition
                                className="relative transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                            >
                                {!this.state.loadingForm ? (
                                    <>
                                        {/* Header */}
                                        <div className="bg-gradient-to-r from-red-600 to-red-700 px-6 py-4">
                                            <div className="flex items-center">
                                                <div className="flex-shrink-0">
                                                    <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                                                        <ExclamationTriangleIcon className="h-6 w-6 text-white" />
                                                    </div>
                                                </div>
                                                <div className="ml-4">
                                                    <h3 className="text-lg font-bold text-white">Aplicar Llamado de Atención</h3>
                                                    <p className="text-red-100 text-sm">Confirma los detalles antes de proceder</p>
                                                </div>
                                                <button
                                                    onClick={() => this.setState({changeStatus:false})}
                                                    className="ml-auto rounded-full p-2 text-white/70 hover:text-white hover:bg-white/20 transition-colors duration-200"
                                                >
                                                    <XMarkIcon className="h-5 w-5" />
                                                </button>
                                            </div>
                                        </div>

                                        {/* Content */}
                                        <div className="px-6 py-6">
                                            {/* Pregunta principal */}
                                            <div className="mb-6">
                                                <div className="flex items-center mb-4">
                                                    <InformationCircleIcon className="h-6 w-6 text-blue-950 mr-3" />
                                                    <h4 className="text-lg font-semibold text-gray-900">
                                                        ¿Estás seguro que deseas aplicar un llamado de atención a esta multa?
                                                    </h4>
                                                </div>
                                                <p className="text-gray-600 text-sm">
                                                    Esta acción es irreversible. Revisa cuidadosamente la información antes de continuar.
                                                </p>
                                            </div>

                                            {/* Detalles de la multa */}
                                            <div className="bg-gray-50 rounded-xl p-4 space-y-3">
                                                <h5 className="font-semibold text-gray-900 mb-3">Detalles de la Multa</h5>
                                                
                                                <div className="grid grid-cols-1 gap-3">
                                                    <div className="flex justify-between items-center py-2 border-b border-gray-200">
                                                        <span className="text-sm font-medium text-gray-600">Estado actual:</span>
                                                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                                            this.state.penalitie?.descripStatus === 'PENDIENTE' ? 'bg-yellow-100 text-yellow-800' :
                                                            this.state.penalitie?.descripStatus === 'PAGADA' ? 'bg-green-100 text-green-800' :
                                                            'bg-gray-100 text-gray-800'
                                                        }`}>
                                                            {this.state.penalitie?.descripStatus}
                                                        </span>
                                                    </div>
                                                    
                                                    <div className="flex justify-between items-center py-2 border-b border-gray-200">
                                                        <span className="text-sm font-medium text-gray-600">Tipo:</span>
                                                        <span className="text-sm text-gray-900 font-medium">{this.state.penalitie?.subTypeDescrip}</span>
                                                    </div>
                                                    
                                                    <div className="flex justify-between items-center py-2 border-b border-gray-200">
                                                        <span className="text-sm font-medium text-gray-600">Infractor:</span>
                                                        <span className="text-sm text-gray-900 font-medium">{this.state.penalitie?.fullnameUser}</span>
                                                    </div>
                                                    
                                                    <div className="flex justify-between items-center py-2 border-b border-gray-200">
                                                        <span className="text-sm font-medium text-gray-600">Cédula:</span>
                                                        <span className="text-sm text-gray-900 font-medium">{this.state.penalitie?.identificationUser}</span>
                                                    </div>
                                                    
                                                    <div className="flex justify-between items-start py-2">
                                                        <span className="text-sm font-medium text-gray-600">Concepto:</span>
                                                        <span className="text-sm text-gray-900 font-medium text-right max-w-xs">
                                                            {this.state.penalitie?.detailFine ? this.state.penalitie.detailFine[0].concept : 'N/A'}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex justify-between items-start py-2">
                                                    <span className="text-sm font-medium text-gray-600">Motivo del Llamado de Atención:</span>
                                                    <textarea
                                                        value={this.state.comment}
                                                        onChange={(e) => this.setState({comment:e.target.value})}
                                                        className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                                        rows={3}
                                                        placeholder="Ingrese el motivo del llamado de atención"
                                                    ></textarea>
                                                </div>
                                            </div>

                                            
                                        </div>

                                        {/* Footer */}
                                        <div className="bg-gray-50 px-6 py-4 flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-3 space-y-3 space-y-reverse sm:space-y-0">
                                            <button
                                                type="button"
                                                onClick={() => this.setState({changeStatus:false})}
                                                className="w-full sm:w-auto inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-950 transition-colors duration-200"
                                            >
                                                Cancelar
                                            </button>
                                            {
                                                this.state.penalitie?.descripStatus !== 'PAGADA' ? (
                                                    <button
                                                        onClick={() => {
                                                            this.setState({confirm:true});
                                                        }}
                                                        type="button"
                                                        className="w-full sm:w-auto inline-flex justify-center items-center px-4 py-2 text-sm font-semibold text-white bg-gradient-to-r from-red-600 to-red-700 rounded-lg hover:from-red-700 hover:to-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-200 transform hover:scale-105"
                                                    >
                                                        <ExclamationTriangleIcon className="h-4 w-4 mr-2" />
                                                        Aplicar Llamado de Atención
                                                    </button>
                                                ) : null
                                            }
                                            
                                        </div>
                                    </>
                                ) : (
                                    <div className="flex flex-col items-center justify-center py-12">
                                        <div className="relative">
                                            <div className="w-16 h-16 bg-blue-950 rounded-full flex items-center justify-center mb-4">
                                                <ShieldCheckIcon className="h-8 w-8 text-white animate-pulse" />
                                            </div>
                                            <div className="absolute -top-1 -left-1 w-18 h-18 border-4 border-blue-200 border-t-blue-950 rounded-full animate-spin"></div>
                                        </div>
                                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Procesando Llamado de Atención</h3>
                                        <p className="text-gray-600">Por favor espera mientras se procesa la solicitud...</p>
                                    </div>
                                )}
                            </DialogPanel>
                        </div>
                    </div>
                </Dialog>
            )
        }

    render() {
        return this.renderList();  
    }
}